export const {translate} = window.oldAddPanel;